import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectShowWelcomerPopup } from '../selectors';
import WelcomerPopup from '@sunbit-dev/ui/src/components/card-apply/components/welcomerPopup/welcomerPopup';
import { hideWelcomerModal } from '../actions/welcomerPopupActions';


const WelcomerPopupContainer:React.FC = () => {

  const dispatch = useDispatch();

  const WelcomerPopupVisible = useSelector(selectShowWelcomerPopup);

  const closeWelcomerPopup = React.useCallback( () => {
    dispatch(hideWelcomerModal());
  },[dispatch]);

  return <>{WelcomerPopupVisible && <WelcomerPopup onClose={closeWelcomerPopup}/>}</>
}

export default WelcomerPopupContainer;
